import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';

import { BasePage } from './bases/BasePage';
import { BreadcrumbSubBar } from '@components/BreadcrumbSubBar';
import { BannerScope } from '@api/banners';
import { BannerEditor } from '@components/banners';
import { EntityPageLayout, InfoCard } from '@components/design-system';

import type { RootState } from '@features/redux/store';

export const BannerManagement: React.FC = () => {
    const { role } = useSelector(({ auth }: RootState) => auth.Roles);
    const canEdit = role.isSuperAdmin;

    return (
        <BasePage>
            <BreadcrumbSubBar />
            <Box sx={{ p: { xs: 1.5, sm: 3 } }}>
                <EntityPageLayout>
                    <InfoCard title='Global Banners' icon={<ImageOutlinedIcon />}>
                        <BannerEditor
                            scope={BannerScope.Global}
                            canEdit={canEdit}
                            wrapped={false}
                            description='Global banners are shown on every kiosk unless the company or reseller has configured their own banners.'
                        />
                    </InfoCard>
                </EntityPageLayout>
            </Box>
        </BasePage>
    );
};
